export enum EDeviceActions {
    GET_AVAILABLE_DEVICES = 'getAvailableDevices',
    GET_DEVICE_RENTALS_HISTORY = 'getDeviceRentalsHistory'
}
